export default "__VITE_ASSET__Bs0fKhHX__"